import { useSyncExternalStore } from "react";

const subscribe = () => () => {};

/**
 * True after hydration, false during SSR and the hydrating render. Replaces the
 * `const [mounted, setMounted] = useState(false); useEffect(() => setMounted(true), [])`
 * idiom without a synchronous setState in an effect.
 */
export function useIsClient(): boolean {
    return useSyncExternalStore(
        subscribe,
        () => true,
        () => false
    );
}
